export default __webpack_public_path__ + "static/media/slider-convertibleNote.f0a27e5d.png";